export default "__VITE_ASSET__Dd5S_tbN__"